// extracted by mini-css-extract-plugin
export default {"footermain":"Footer_footermain__VXPE1","footeritems":"Footer_footeritems__99Glw","footer":"Footer_footer__1ccCO"};